import { PasswordResetLinkCreatorComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const PasswordResetAdmin = () => (
	<PasswordResetLinkCreatorComponent signInLink={APP_ROUTES.SIGN_IN_ADMIN} />
);

export default PasswordResetAdmin;
